import Vue from 'vue'
import 'vant/lib/index.css'
// 按需引用vant-ui库, 在.babelrc中有配置
// vant-ui 文档地址：https://youzan.github.io/vant/#/zh-CN/home
import {
  Button,
  NavBar,
  Image,
  Search,
  Icon,
  Tab,
  Tabs,
  ActionSheet,
  Calendar,
  Sticky,
  List,
  PullRefresh,
  NoticeBar,
  Form,
  Field,
  Area,
  Popup,
  Dialog,
} from 'vant'
Vue.use(Button)
Vue.use(NavBar)
Vue.use(Image)
Vue.use(Search)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(ActionSheet)
Vue.use(Calendar)
Vue.use(Sticky)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(NoticeBar)
Vue.use(Form)
Vue.use(Field)
Vue.use(Area)
Vue.use(Popup)
Vue.use(Dialog)

import { RadioGroup, Radio } from 'vant'
Vue.use(Radio)
Vue.use(RadioGroup)

import { Toast } from 'vant'
Vue.use(Toast)

import { Checkbox, CheckboxGroup } from 'vant'
Vue.use(Checkbox)
Vue.use(CheckboxGroup)

import { Picker } from 'vant'
Vue.use(Picker)

import { DatetimePicker } from 'vant'
Vue.use(DatetimePicker)

import { Cell, CellGroup } from 'vant'
Vue.use(Cell)
Vue.use(CellGroup)

import { Col, Row } from 'vant'
Vue.use(Col)
Vue.use(Row)

import { Grid, GridItem } from 'vant'
Vue.use(Grid)
Vue.use(GridItem)

import { Swipe, SwipeItem } from 'vant'
Vue.use(Swipe)
Vue.use(SwipeItem)

import { Lazyload } from 'vant'
Vue.use(Lazyload)

import { Panel } from 'vant'
Vue.use(Panel)

import { Tag } from 'vant'
Vue.use(Tag)

import { Step, Steps } from 'vant'

Vue.use(Step)
Vue.use(Steps)

import { Image as VanImage } from 'vant';
Vue.use(VanImage)

import { Uploader } from 'vant';
Vue.use(Uploader);

import { ImagePreview } from 'vant';
Vue.use(ImagePreview);